import React from 'react';
import { Box, Card, Container, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { FallbackContentProps } from './FallbackContent';
import { FallbackIcon } from './FallbackIcon';
import { FallbackType } from "@/features/auth/domain/auth.types.ts";

export function PageFallback({title, action, role, icon}: Omit<FallbackContentProps, 'type'>): React.ReactElement {
  const theme = useMantineTheme();

  return (
    <Container size="xl" px="xs">
      <Stack gap="lg" mt="xl">
        <Title order={1}>{title || 'Access Restricted'}</Title>
        <Card radius="lg"
              p="xl"
              shadow="md"
              style={{
                textAlign: 'center',
                maxWidth: 600,
                margin: '0 auto',
                transition: 'all 0.3s ease'
              }}>
          <Stack align="center" gap="lg">
            <Box style={{color: theme.colors.gray[5]}}>
              <FallbackIcon type={FallbackType.Page} customIcon={icon}/>
            </Box>
            <Stack gap="xs">
              <Text size="xl" fw={600} c="dimmed">
                {role} Access Required
              </Text>
              <Text size="md" c="dimmed">
                You need {role} role or higher to {action}
              </Text>
              <Text size="sm" c="dimmed" mt="sm">
                Please contact your system administrator if you believe you should have access to this
                area.
              </Text>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
}